
import { Component, Inject, OnInit } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { NgForm } from '@angular/forms';
import { ReactiveFormsModule, FormBuilder, FormGroup, FormControl, Validators } from '@angular/forms';
import { environment } from "src/environments/environment";
import { OpenModal } from '../../../OpenModal'
import { BackOfficeSession } from 'src/app/Services/Api.BackOfficeSession/BackOfficeSession';
import { TypeDialog, ButtonsDialog } from '../../../model-type';

@Component({
  selector: 'app-recuperar',
  templateUrl: '../RecuperarContrasena/recuperar.component.html',
  styleUrls: ['../RecuperarContrasena/recuperar.component.css']
})

export class RecuperarComponent {


  public form: FormGroup;
  submitted = false;
  Loading = false;
  env = environment;

  resolved(captchaResponse: string) {
    console.log(`Resolved captcha with response: ${captchaResponse}`);
  }

  constructor(private router: Router, private fb: FormBuilder,
    private _OpenModal: OpenModal,
    private _authenticationService: BackOfficeSession, private OModal: OpenModal) {
    this.form = this.fb.group({
      email: ['', Validators.compose([Validators.required, Validators.email])],
      recaptchaReactive: [null, Validators.required]
    });

  }

  ngOnInit = () => {
    this.buildForm();
  }

  private buildForm() {
    this.form = this.fb.group({});
  }

  onSubmit = () => {
    this.submitted = true;
    if (this.form.valid) {
      this.Loading = true;
      this._authenticationService.recuperarPassword(this.form.get('email').value).subscribe(res => {
        let error = (<any>res).error;

        if (error == null) {
          let dialog = this.OModal.openDialog(TypeDialog.success, 'Correcto', 'Contraseña enviada a su correo.', ButtonsDialog.ok, 300);

          let record = (<any>res).record;
          this.Loading = false;
          dialog.afterClosed().subscribe(res => {
            this.router.navigate(["/login"]);
          });
        }
        else {
          this.OModal.openDialog(TypeDialog.information, 'Advertencia', 'Email incorrecto.', ButtonsDialog.ok, 300);

        }

      },
        err => {
          if (err.status === 404) {
            this._OpenModal.openDialog(TypeDialog.warn, 'Error',
              'Usuario y/o Password Incorrecto', ButtonsDialog.ok, 300);
          }

        }, () => this.Loading = false
      );

    } else {

      console.error('Invalido');
    }
  }

  get f() {
    return this.form.controls;
  }

  resetValue = () => {
    this.router.navigate(["/login"]);

  }

  setKindPerson = () => { }

  onInputChange(event: any) {
    const initalValue = event.target.value;

    event.target.value = event.target.value.replace(/ /g, '');
    if (initalValue !== event.target.value) {
      event.stopPropagation();
    }
  }
}
